import { useEffect, useState } from "react";
import LocalizedStrings from "react-localization";
import Loading from "./Loading";
import ReactDOM from "react-dom/client";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

let strings = new LocalizedStrings({
    ru: {
        select_a_date: "Выберите дату:",
        choose: "Выбрать",
        no_data: "Нет занятий. Выберите другой день.",
    },
    et: {
        select_a_date: "Vali kuupäev:",
        choose: "Vali",
        no_data: "Klass puudub. Valige teine päev.",
    },
});

const SingleRegistrationFilter = () => {
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [trains, setTrains] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    strings.setLanguage(localStorage.getItem("language"));

    const minDate = new Date();
    const maxDate = new Date();
    maxDate.setDate(maxDate.getDate() + 14);

    useEffect(() => {
        getGroups();
    }, []);

    const getGroups = () => {
        setIsLoading(true);

        fetch("/groups/single-train/list")
            .then((res) => res.json())
            .then((data) => {
                setTrains(data);
                setIsLoading(false);
            })
            .catch(() => {
                setIsLoading(false);
            });
    };

    const getFilteredGroups = async (date) => {
        setIsLoading(true);

        fetch(`/groups/single-train/list?date=${formatDate(date)}`)
            .then((res) => res.json())
            .then((groups) => {
                setTrains(groups);
                setIsLoading(false);
            })
            .catch(() => {
                setIsLoading(false);
            });
    };

    const handleDateChange = (value) => {
        setSelectedDate(value);
        getFilteredGroups(value);
    };

    const formatDate = (value) => {
        const date = new Date(value);
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const day = date.getDate().toString().padStart(2, "0");

        return `${day}/${month}/${year}`;
    };

    return (
        <div>
            <div className="flex flex-col items-center bg-[#25346D] py-4 px-8 gap-x-4 gap-y-3 sm:flex-row">
                <div className="text-white text-xl sm:font-semibold sm:text-base sm:leading-[19px] lg:text-xl lg:leading-[24px]">
                    {strings.select_a_date}
                </div>
                <div className="w-[143px]">
                    <DatePicker
                        selected={selectedDate}
                        onChange={handleDateChange}
                        dateFormat="dd/MM/yyyy"
                        minDate={minDate}
                        maxDate={maxDate}
                        className="w-full text-dark-main text-base bg-white py-3 px-6 rounded-3xl sm:font-semibold sm:text-base sm:leading-[19px] cursor-pointer"
                    />
                </div>
            </div>

            <div>
                {isLoading ? (
                    <div className="py-32">
                        <Loading />
                    </div>
                ) : trains.length > 0 ? (
                    <div className="py-6 flex flex-col gap-y-2">
                        {trains.map(
                            (train) =>
                                <div
                                    key={train.group_id}
                                    className="bg-[#F4F5F8] rounded-2xl"
                                >
                                    <div className="flex flex-row items-center justify-between p-4">
                                        <div className="flex flex-col gap-x-11 gap-y-3 lg:flex-row lg:items-center">
                                            <div className="flex flex-col text-5">
                                                <div className="font-medium text-2xl text-dark-main">
                                                    {train.start_time}{" "}-{" "}{train.end_time}
                                                </div>
                                                <span className="text-[#B9BABC] lg:text-center">
                                                    {train.date}
                                                </span>
                                            </div>
                                            <div>
                                                <div className="flex items-center mb-2">
                                                    <svg
                                                        className="w-5 h-5 mr-2 lg:w-8 lg:h-8 lg:mr-4"
                                                        viewBox="0 0 30 30"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            d="M15 26.25C21.2132 26.25 26.25 21.2132 26.25 15C26.25 8.7868 21.2132 3.75 15 3.75C8.7868 3.75 3.75 8.7868 3.75 15C3.75 21.2132 8.7868 26.25 15 26.25Z"
                                                            stroke="#25346D"
                                                            strokeWidth="1.5"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                        <path
                                                            d="M15 18.75C17.5888 18.75 19.6875 16.6513 19.6875 14.0625C19.6875 11.4737 17.5888 9.375 15 9.375C12.4112 9.375 10.3125 11.4737 10.3125 14.0625C10.3125 16.6513 12.4112 18.75 15 18.75Z"
                                                            stroke="#25346D"
                                                            strokeWidth="1.5"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                        <path
                                                            d="M7.47656 23.3672C8.18193 21.9778 9.25823 20.8109 10.5862 19.9958C11.9141 19.1807 13.4418 18.7493 15 18.7493C16.5582 18.7493 18.0859 19.1807 19.4138 19.9958C20.7418 20.8109 21.8181 21.9778 22.5234 23.3672"
                                                            stroke="#25346D"
                                                            strokeWidth="1.5"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                    </svg>

                                                    <p className="text-sm text-dark-main">
                                                        {train.trainer_name}
                                                    </p>
                                                </div>

                                                <div className="flex items-center mb-2">
                                                    <svg
                                                        className="w-5 h-5 mr-2 lg:w-8 lg:h-8 lg:mr-4"
                                                        viewBox="0 0 30 30"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            d="M15 15.9375C17.0711 15.9375 18.75 14.2586 18.75 12.1875C18.75 10.1164 17.0711 8.4375 15 8.4375C12.9289 8.4375 11.25 10.1164 11.25 12.1875C11.25 14.2586 12.9289 15.9375 15 15.9375Z"
                                                            stroke="#25346D"
                                                            strokeWidth="1.5"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                        <path
                                                            d="M24.375 12.1875C24.375 20.625 15 27.1875 15 27.1875C15 27.1875 5.625 20.625 5.625 12.1875C5.625 9.7011 6.61272 7.31653 8.37087 5.55837C10.129 3.80022 12.5136 2.8125 15 2.8125C17.4864 2.8125 19.871 3.80022 21.6291 5.55837C23.3873 7.31653 24.375 9.7011 24.375 12.1875V12.1875Z"
                                                            stroke="#25346D"
                                                            strokeWidth="1.5"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                    </svg>
                                                    <p className="text-sm text-dark-main">
                                                        {train.pool_name}

                                                        <p className={"text-[#a9a9ab]"}>
                                                            {train.pool_address}
                                                        </p>
                                                    </p>
                                                </div>

                                                <div className="flex items-center">
                                                    <svg className="w-5 h-5 mr-2 lg:w-8 lg:h-8 lg:mr-4"
                                                         viewBox="0 0 30 30" fill="none"
                                                         xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M11.25 14.0625C16.4277 14.0625 20.625 12.1737 20.625 9.84375C20.625 7.5138 16.4277 5.625 11.25 5.625C6.07233 5.625 1.875 7.5138 1.875 9.84375C1.875 12.1737 6.07233 14.0625 11.25 14.0625Z"
                                                            stroke="#25346D" strokeWidth="1.5"
                                                            strokeLinecap="round" strokeLinejoin="round"/>
                                                        <path
                                                            d="M1.875 9.84375V14.5312C1.875 16.8633 6.07031 18.75 11.25 18.75C16.4297 18.75 20.625 16.8633 20.625 14.5312V9.84375"
                                                            stroke="#25346D" strokeWidth="1.5"
                                                            strokeLinecap="round" strokeLinejoin="round"/>
                                                        <path d="M7.5 13.7109V18.3984" stroke="#25346D"
                                                              strokeWidth="1.5" strokeLinecap="round"
                                                              strokeLinejoin="round"/>
                                                        <path
                                                            d="M20.625 11.332C24.9023 11.7305 28.125 13.4297 28.125 15.4688C28.125 17.8008 23.9297 19.6875 18.75 19.6875C16.4531 19.6875 14.3437 19.3125 12.7148 18.7031"
                                                            stroke="#25346D" strokeWidth="1.5"
                                                            strokeLinecap="round" strokeLinejoin="round"/>
                                                        <path
                                                            d="M9.375 18.668V20.1562C9.375 22.4883 13.5703 24.375 18.75 24.375C23.9297 24.375 28.125 22.4883 28.125 20.1562V15.4688"
                                                            stroke="#25346D" strokeWidth="1.5"
                                                            strokeLinecap="round" strokeLinejoin="round"/>
                                                        <path d="M22.5 19.3359V24.0234" stroke="#25346D"
                                                              strokeWidth="1.5" strokeLinecap="round"
                                                              strokeLinejoin="round"/>
                                                        <path d="M15 13.7109V24.0234" stroke="#25346D"
                                                              strokeWidth="1.5" strokeLinecap="round"
                                                              strokeLinejoin="round"/>
                                                    </svg>


                                                    <p className="text-sm text-dark-main">
                                                        22 €
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <a
                                            href={`/groups/single-train/register?group=${train.group_id}&date=${train.date}&time=${train.start_time} - ${train.end_time}`}
                                            className="w-[30px] h-[30px] overflow-hidden cursor-pointer lg:hidden"
                                        >
                                            <svg
                                                className="w-full h-full"
                                                width="12"
                                                height="22"
                                                viewBox="0 0 12 22"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M1 1L11 11L1 21"
                                                    stroke="black"
                                                    strokeWidth="2"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                        </a>
                                        <a
                                            href={`/groups/single-train/register?group=${train.group_id}&date=${train.date}&time=${train.start_time} - ${train.end_time}`}
                                            className="hidden lg:inline-block py-[10px] px-6 bg-white rounded-[10px] text-base leading-[30px] font-semibold transition-colors hover:bg-[#25346D] hover:text-white"
                                        >
                                            {strings.choose}
                                        </a>
                                    </div>
                                </div>
                        )}
                    </div>
                ) : (
                    <div className="py-28 text-center mb-4 text-2xl sm:text-[40px] sm:leading-[52px]">
                        {strings.no_data}
                    </div>
                )}
            </div>
        </div>
    );
};

const section = document.getElementById("single-registration");
if (section) {
    const root = ReactDOM.createRoot(
        document.getElementById("single-registration")
    );
    root.render(<SingleRegistrationFilter />);
}
